import { ProductCategory } from "@/products/entities/product-category"

export default class ProductFilter {
  public text = ''
  public categories: ProductCategory[] = []
}